import React from 'react'

import './index.scss'

// success
// warning
// error
// info

const swalIcons = {
  success: <i className='flaticon2-checkmark'></i>,
  warning: <i className='flaticon-warning'></i>,
  error: <i className='flaticon-cancel'></i>,
  info: <i className='flaticon-exclamation-2'></i>
}

const swalTitles = {
  success: 'COMPLETADO',
  warning: 'ADVERTENCIA',
  error: 'ERROR',
  info: 'INFO'
}

const ZariSweetAlert = ({ tipo, mensaje, onSuccess, showCerrar, onClose, textoCerrar, textoAceptar }) => {
  const buttonRef = React.useRef(null)

  React.useEffect(() => {
    setTimeout(() => {
      buttonRef.current.focus()
    }, [250])
  }, [])

  const clickCerrar = () => {
    let containerDomNode = document.getElementById('zr-sweet-alert-container')
    if (containerDomNode) {
      containerDomNode.parentNode.removeChild(containerDomNode)
    }
    if (onClose) {
      onClose()
    }
  }

  const clickAceptar = () => {
    let containerDomNode = document.getElementById('zr-sweet-alert-container')
    if (containerDomNode) {
      containerDomNode.parentNode.removeChild(containerDomNode)
    }
    if (onSuccess) {
      onSuccess()
    }
  }

  return (
    <div className='zr-popalert__inner-wrapper'>
      <div className={`zr-popalert ${tipo}`}>
        <div className='zr-popalert__header'>
          {swalIcons[tipo]}
          {swalTitles[tipo]}
        </div>
        <div className='zr-popalert__body'>
          <p className='zr-popalert__body-message'>{mensaje}</p>
          <div className='zr-popalert__body-buttons__container'>
            {showCerrar && (
              <button type='button' className='zr-popalert__body-buttons__cerrar' onClick={clickCerrar}>
                {textoCerrar || 'CERRAR'}
              </button>
            )}
            <button
              ref={buttonRef}
              type='button'
              className='zr-popalert__body-buttons__aceptar'
              autoFocus
              onClick={clickAceptar}
            >
              {textoAceptar || 'ACEPTAR'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ZariSweetAlert
